/* Bundle child variant swap for mobile cart page. Shopify has no
   "change variant on line" endpoint, so we remove + add a new line
   with the same qty + _Bundle Parent properties. Wired from main-cart-mobile.
   Exposes window.HCS_CART_BUNDLE_SWAP.init(root, fmtMoney, refreshCartPricing). */
(function(){
  var cache = {};
  function load(h){
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch('/products/'+h+'.js',{cache:'force-cache'})
      .then(function(r){return r.ok?r.json():null;})
      .then(function(p){if(p&&p.variants){cache[h]=p;return p;}return null;})
      .catch(function(){return null;});
  }
  function init(root, fmtMoney, refresh){
    if (!root) return;
    /* Handles both mobile ([data-cm4-bundle-variant]) + desktop ([data-cd-bundle-variant]).
       Row lookup + element queries include both class namespaces so the same helper
       runs on /cart?preview_theme_id= for either viewport. */
    root.querySelectorAll('[data-cm4-bundle-variant],[data-cd-bundle-variant]').forEach(function(sel){
      var row = sel.closest('[data-cm4-bundle-child],[data-cd-bundle-child]');
      if (!row) return;
      var handle = row.getAttribute('data-bundle-handle');
      if (handle) load(handle);
      sel.addEventListener('change', function(){
        var newVid = parseInt(sel.value,10);
        var oldKey = row.getAttribute('data-bundle-key') || row.getAttribute('data-key');
        var qty = parseInt(row.getAttribute('data-bundle-qty'),10)||1;
        var parentTitle = row.getAttribute('data-parent-title');
        var parentId = row.getAttribute('data-parent-id');
        var parentVid = row.getAttribute('data-parent-variant-id');
        if (!newVid||!oldKey) return;
        sel.disabled = true; row.style.opacity='0.6';
        load(handle).then(function(p){
          if (p){
            var v = p.variants.find(function(x){return x.id===newVid;});
            if (v){
              var img = row.querySelector('[data-cm4-bundle-img], [data-hcs-bundle-img], .cd-bundle-row-img img');
              var src = (v.featured_image&&v.featured_image.src)||p.featured_image;
              if (img&&img.tagName==='IMG'&&src) img.src = src.replace(/\.(jpg|jpeg|png|webp)(\?.*)?$/i,'_240x240.$1$2');
              /* v.price is the stored variant price — the "was" for bundle display.
                 Don't use compare_at; that would make PDP/cart inconsistent with checkout. */
              var orig = v.price*qty, disc = Math.round(orig*0.8);
              var pe=row.querySelector('[data-cm4-bundle-price],[data-cd-bundle-price]'),
                  ce=row.querySelector('[data-cm4-bundle-compare],.cd-bundle-row-compare'),
                  se=row.querySelector('[data-cm4-bundle-savings],[data-cd-bundle-savings]');
              if (pe) pe.textContent = fmtMoney(disc);
              if (ce) ce.textContent = fmtMoney(orig);
              if (se) se.textContent = 'You save '+fmtMoney(orig-disc);
            }
          }
          return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:oldKey,quantity:0})})
            .then(function(r){return r.json();})
            .then(function(){
              return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:newVid,quantity:qty,properties:{'_Bundle Parent':parentTitle,'_Bundle Parent ID':parentId,'_Bundle Parent Variant':parentVid,'_bundle_discount':'20%'}}]})});
            });
        }).then(function(){
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (typeof refresh==='function') refresh();
          setTimeout(function(){window.location.reload();},200);
        }).catch(function(err){
          console.warn('[cart-bundle-swap]',err);
          sel.disabled=false; row.style.opacity='';
        });
      });
    });
  }
  window.HCS_CART_BUNDLE_SWAP = { init: init };
})();
